import type { ApolloError } from '@apollo/client'
import type { GraphQLFormattedError } from 'graphql'

/**
 * Parses a GraphQL error and returns an array of errors.
 * @param apolloError - The Apollo error to parse.
 * @returns An array of errors.
 */
export const graphQLErrorParser = (apolloError: ApolloError): Error[] => {
  const { graphQLErrors: errors } = apolloError

  const errorArray = errors.map((e: GraphQLFormattedError) => ({
    code: e.extensions?.code || '',
    extensions: e.extensions || {},
    message: e.message || '',
    name: 'GraphQLError'
  }))
  return errorArray
}
